<template>
  <div v-if="count" class="color-count">
    Available in {{ count }} colors<span v-if="saleCount && count > saleCount">, {{ saleCount }} on sale</span>.
  </div>
</template>

<style scoped>
</style>

<script>
export default {
    props: {
        count: {
            type: Number,
            default: 0
        },
        saleCount: {
            type: Number,
            default: 0
        },
    },
}
</script>
